import React from "react";
import "./Pagina.css";

const Statement = () => {
  return (
    <div className="pagina">
      <div className="pagina-inner">
        <div className="pagina-testo">
          <h1 className="pagina-titolo">STATEMENT</h1>
          <p>
            Il lavoro indaga le connessioni umane accentrando il focus sulla
            partecipazione e la relazione tra l'opera e il pubblico. Lo studio
            del colore, della materia e della sua modulazione sono in costante
            sperimentazione: i progetti nascono dall'incontro, che ad oggi è una
            tematica da affrontare anche sotto l'aspetto di altri medium.
            L'interesse di un'arte condivisa, che parli dell'essere umano, è
            l'ispirazione della produzione artistica.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Statement;
